import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import TransactionsService from 'donor-elf-web/services/transactions-service';

export default class TransactionsEditSaveRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;
  @service declare transactionsService: TransactionsService;

  model() {
    this.navbarSettings.title = 'Saving Transactions';
  }

  redirect() {
    if (this.transactionsService.lineItemInfos.length === 0) {
      this.router.transitionTo('funds.fund.transactions.edit.enter', 'add');
    }
  }
}
